export const SOFTLINE_API_PMS_STEMPELTERMINAL_TAGESUEBERSICHT = '/v1/pms/stempelterminal/uebersicht/{{chipid}}';
export const SOFTLINE_API_PMS_STEMPELTERMINAL_CODES = '/v1/pms/stempelterminal/codes/{{chipid}}';
export const SOFTLINE_API_PMS_STEMPELTERMINAL_STEMPELN = '/v1/pms/stempelterminal/stempeln';
